import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    notice: String,
    alert: String,
  }

  connect() {
    if (this.noticeValue) {
      this.show(this.noticeValue, "success")
    } else if (this.alertValue) {
      this.show(this.alertValue, "error")
    }
  }

  show(message, icon) {
    Swal.fire({
      text: message,
      icon: icon,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      customClass: {
        popup: "!mt-14",
      },
    })
  }
}
